import { jsxs as s, jsx as n } from "react/jsx-runtime";
import { c } from "../clsx-OuTLNxxd.js";
import { B as l } from "../Badge-U9u-iOJu.js";
import { a as B } from "../Tooltip-BNTfqKSo.js";
import '../Comparison.css';const v = "_comparisonContainer_7y5yr_32", C = "_valuesContainer_7y5yr_41", f = "_value_7y5yr_41", u = "_label_7y5yr_49", $ = "_leftBadge_7y5yr_59", b = "_rightBadge_7y5yr_63", N = "_progressBarContainer_7y5yr_87", w = "_hasMiddleValue_7y5yr_93", A = "_progressBar_7y5yr_87", R = "_leftBar_7y5yr_100", x = "_rightBar_7y5yr_103", M = "_separatorContainer_7y5yr_125", W = "_middleBadge_7y5yr_138", j = "_badgeRightAligned_7y5yr_151", a = {
  comparisonContainer: v,
  valuesContainer: C,
  value: f,
  label: u,
  leftBadge: $,
  rightBadge: b,
  progressBarContainer: N,
  hasMiddleValue: w,
  progressBar: A,
  leftBar: R,
  rightBar: x,
  separatorContainer: M,
  middleBadge: W,
  badgeRightAligned: j
}, q = (o, t = "Comparison") => {
  const i = o.reduce((e, d) => e + d, 0), r = 100;
  return i !== r ? (console.warn(`${t} component: The sum of values must equal ${r}. Current sum: ${i}`), !1) : !0;
}, k = ({
  comparisonLabel: o,
  leftValue: t,
  middleText: i = "DRAW",
  middleValue: r = 0,
  rightValue: e,
  tooltipText: d,
  ...g
}) => {
  if (!q([t, r, e]))
    return null;
  const _ = `${t}%`, h = `${r}%`, m = `${e}%`, p = r > 0, y = r > 0 && e <= 20;
  return /* @__PURE__ */ s(
    "div",
    {
      "aria-label": `${o} comparison bar with ${t}% on the left, ${r}% draw in the middle, and ${e}% on the right.`,
      className: a.comparisonContainer,
      "data-cxy-name": "comparison",
      role: "region",
      ...g,
      children: [
        /* @__PURE__ */ s("div", { className: a.valuesContainer, children: [
          /* @__PURE__ */ n("span", { className: a.value, "data-testid": "comparison-left", children: /* @__PURE__ */ s(l, { className: a.leftBadge, children: [
            t,
            "%"
          ] }) }),
          /* @__PURE__ */ s("div", { className: a.label, children: [
            o,
            " ",
            d && /* @__PURE__ */ n(B, { children: d })
          ] }),
          /* @__PURE__ */ n("span", { className: a.value, "data-testid": "comparison-right", children: /* @__PURE__ */ s(l, { className: a.rightBadge, children: [
            e,
            "%"
          ] }) })
        ] }),
        /* @__PURE__ */ s("div", { className: c(a.progressBarContainer, { [a.hasMiddleValue]: p }), children: [
          /* @__PURE__ */ n(
            "div",
            {
              className: `${a.progressBar} ${a.leftBar}`,
              "data-testid": "comparison-left-bar",
              style: { width: _ }
            }
          ),
          /* @__PURE__ */ n(
            "div",
            {
              className: a.separatorContainer,
              "data-testid": "comparison-middle-bar",
              style: {
                width: r ? `${r}%` : void 0
              },
              children: r > 0 && /* @__PURE__ */ s(l, { className: c(a.middleBadge, { [a.badgeRightAligned]: y }), children: [
                i,
                " ",
                h
              ] })
            }
          ),
          /* @__PURE__ */ n(
            "div",
            {
              className: `${a.progressBar} ${a.rightBar}`,
              "data-testid": "comparison-right-bar",
              style: { width: m }
            }
          )
        ] })
      ]
    }
  );
};
export {
  k as Comparison
};
